import CardVisaForm from './CardVisaForm';
import TransferIBAN from './TransferIBAN';
import ReferenceCode from './ReferenceCode';
import PayPay from './PayPay';


function PaymentMethod({ type, basket ,custoTotal}) {
  switch (type) {
    case 'visa':
      return <CardVisaForm basket={basket}  custoTotal={custoTotal} />;
    case 'iban':
      return <TransferIBAN basket={basket} custoTotal={custoTotal}/>;
    case 'ref':
      return <ReferenceCode basket={basket} custoTotal={custoTotal}/>;
    case 'paypay':
      return <PayPay basket={basket}  />;
    default:
      return null;
  }
}

export default PaymentMethod;
